import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getSessionStorageValue, STORAGE_KEYS, clearSessionStorage } from '../SessionStorage';

/**
 * Validates that critical booking session data exists.
 * Redirects to home if any critical data is missing.
 * Use on pages that require an active booking session.
 *
 * @param {Object} options - Configuration options
 * @param {string[]} options.requiredKeys - Array of STORAGE_KEYS to validate
 * @param {boolean} options.allowHome - If true, don't redirect when on home page
 */
export const useValidateBookingSession = (options = {}) => {
  const navigate = useNavigate();
  const {
    requiredKeys = [
      STORAGE_KEYS.APPOINTMENT_TYPE,
    ],
    allowHome = true,
  } = options;

  useEffect(() => {
    const location = window.location.pathname;
    if (allowHome && location === '/') return;

    const hasAllRequiredData = requiredKeys.every((key) => {
      const value = getSessionStorageValue(key);
      return value !== null && value !== undefined && value !== '';
    });

    if (!hasAllRequiredData) {
      clearSessionStorage();
      navigate('/');
    }
  }, [navigate, requiredKeys, allowHome]);
};
